<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Physical Info`"
      :headers="[
          { text: 'ID', value: 'id' },
          { text: 'Smartdevice Id', value: 'smartdeviceid' },
          { text: 'Serial Number', value: 'serialnum' },
          { text: 'Physical Type', value: 'physicaltype' },
          { text: 'Device Name', value: 'devicename' }
        ]"
      :url="`/manifest/physicalinfo`"
      :apiResponseField="`physicalinfolist`"
      :onClickRoute="`AssetSingle`"
      :onClickParams="getOnClickParams"
      :editable="true"
      :saveUrl="`manifest/physicalinfo/bulk?ids_to_update=`">
    </GenericListTable>

  </v-card>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'
export default {
  name: 'PhysicalListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Smartdevice id', value: 'smartdeviceid' },
        { text: 'Serial Number', value: 'serialnum' },
        { text: 'Physical type', value: 'physicaltype' },
        { text: 'Device name', value: 'devicename' }
      ]
    }
  },
  methods: {
    getOnClickParams (item) {
      var tempassetid = item.serialnum
      if (item.physicaltype === 'Arad') { // This will need changing as more physicaltypes are used
        tempassetid = item.serialnum + 'Ara'
      }// TODO the other manufacturers
      return {
        id: tempassetid

      }
    }
  }
}
</script>
